// Content that used to live in src/pages/index.md and was edited through
// Netlify CMS. It is plain data so the homepage stays declarative and the
// texts are editable without touching JSX.

import obrazek1 from "../img/optika-vzadu.jpg";
import obrazek2 from "../img/pano_52.jpeg";
import obrazek3 from "../img/pano_56.jpeg";
import sectionImage from "../img/screenshot_20240620_154241_instagram.jpg";

const home = {
  // Shown as a coloured strip above the slider. Leave empty to hide it.
  disclaimer: "",

  uvodniText: {
    firstRow: "Vaše",
    secondRow: "známá optika",
    thirdRow: "na náměstí ve",
    coloredText: "Volyni",
  },

  uvodniFoto: [
    { src: obrazek1, alt: "interiér optiky" },
    { src: obrazek2, alt: "panorama optiky" },
    { src: obrazek3, alt: "panorama prodejny" },
  ],

  section: {
    heading: "Kdo jsme?",
    text: "Jsme lokální optika ve Volyni s dlouholetou tradicí, kvalifikovaným personálem a příjemným prostředím. Nabízíme široký výběr dioptrických i slunečních brýlí, brýlových čoček, optických doplňků a optometrických služeb. Přijďte se přesvědčit na vlastní oči a udělejte si radost novými brýlemi a ostrým viděním na všechny vzdálenosti.",
    image: { src: sectionImage, alt: "ilustrační foto brýlí" },
  },
};

export default home;
